"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISABLE_GUEST_SESSION_IFRAME = exports.DEFAULT_USER_LOCATION_DATA = exports.DEFAULT_LOCALE_DATA = exports.DEFAULT_WEB_SHELL_CLIENT_INFO = exports.ANALYTICS_SCRIPT = exports.PRIVACY_CORE_SCRIPT = exports.CN_GUEST_SESSION_SCRIPT = exports.DATA_CAPTURE_SCRIPT = exports.MODAL_ROOT_ID = exports.GUEST_SESSION_IFRAME_SRC = exports.GUEST_SESSION_ORIGIN = exports.WEB_SHELL_CLIENT_BUNDLE_URL = exports.VENDOR_SCRIPT_REACT_DOM_URL = exports.VENDOR_SCRIPT_REACT_URL = exports.SHARED_ASSET_HOST = exports.HOST_NAME = exports.V3 = exports.NAV_VERSION = exports.ENABLE_ASYNC_CHAT = exports.KEEPALIVE = exports.PRE_FETCH_DEPENDENCIES = void 0;
exports.PRE_FETCH_DEPENDENCIES = {
    REACT: `React`,
    REACT_DOM: `ReactDOM`,
    REMOTE: `Remote`
};
exports.KEEPALIVE = {
    HTTP_KEEPALIVE_TIMEOUT: 61000,
    HTTP_HEADERS_TIMEOUT: 65000
};
exports.ENABLE_ASYNC_CHAT = (_b = (_a = process.env.NEXT_PUBLIC_ENABLE_ASYNC_CHAT) !== null && _a !== void 0 ? _a : process.env.ENABLE_ASYNC_CHAT) !== null && _b !== void 0 ? _b : `false`;
exports.NAV_VERSION = `navVersion`;
exports.V3 = `v3`;
exports.HOST_NAME = (_d = (_c = process.env.WS_HOST_NAME) !== null && _c !== void 0 ? _c : process.env.NEXT_PUBLIC_HOST_NAME) !== null && _d !== void 0 ? _d : process.env.HOST_NAME;
/**
 * The host that serves assets shared across nike.com and off-dotcom build variants
 * (e.g. vendor scripts, privacy-core, translations). Defaults to HOST_NAME so existing
 * (nike.com / CN) variants are unaffected; build variants whose site host diverges from
 * the shared-asset host (e.g. Jordan Drops on 232323232323.com, whose shared assets still
 * live on nike.com) can override this independently via NEXT_PUBLIC_SHARED_ASSET_HOST.
 */
exports.SHARED_ASSET_HOST = (_f = (_e = process.env.WS_SHARED_ASSET_HOST) !== null && _e !== void 0 ? _e : process.env.NEXT_PUBLIC_SHARED_ASSET_HOST) !== null && _f !== void 0 ? _f : exports.HOST_NAME;
exports.VENDOR_SCRIPT_REACT_URL = `https://${exports.SHARED_ASSET_HOST}/assets/vendor/react/18.3.1/react.production.min.js`;
exports.VENDOR_SCRIPT_REACT_DOM_URL = `https://${exports.SHARED_ASSET_HOST}/assets/vendor/react-dom/18.3.1/react-dom.production.min.js`;
/**
 * The evergreen web-shell-client UMD bundle URL for the current build variant.
 *
 * Resolution order: BUNDLE_PATH_PREFIX env var -> per-host fallback below (JD deploys to the
 * `web-shell-client-jd` S3 folder) -> default "web-shell-client".
 *
 * See specs/TG-8957-guest-session-origin-decouple/spec.md for the full per-host resolution table
 * and rationale.
 */
const WEB_SHELL_CLIENT_BUNDLE_PATH_PREFIX_FALLBACK_BY_HOST = {
    [`www.232323232323.com`]: `web-shell-client-jd`,
    [`uat.232323232323.com`]: `web-shell-client-jd`
};
exports.WEB_SHELL_CLIENT_BUNDLE_URL = `https://${exports.HOST_NAME}/static/uxf/${process.env.BUNDLE_PATH_PREFIX ||
    WEB_SHELL_CLIENT_BUNDLE_PATH_PREFIX_FALLBACK_BY_HOST[exports.HOST_NAME] ||
    `web-shell-client`}/v1/bundle.umd.js`;
/**
 * The origin that serves the guest-session iframe (dotcom.guest-session-html).
 *
 * Resolution order: NEXT_PUBLIC_GUEST_SESSION_ORIGIN env var -> per-host fallback below, for hosts
 * with no deployment of their own -> default `https://${HOST_NAME}`.
 *
 * The fallback map is an exact-host match, not a prefix match, so nike.com UAT (no deployment of
 * its own -> falls back to nike.com prod) and JD UAT (has its own deployment and would be blocked
 * from framing JD's prod host by X-Frame-Options -> must NOT fall back) resolve differently
 * despite both being "uat.*" hosts.
 *
 * See specs/TG-8957-guest-session-origin-decouple/spec.md for the full per-host resolution table
 * and the evidence behind each fallback entry.
 */
const GUEST_SESSION_ORIGIN_FALLBACK_BY_HOST = {
    [`uat.nike.com`]: `https://www.nike.com`,
    [`www.nike.com.cn`]: `https://www.nike.com`,
    [`localhost.nike.com`]: `https://www.nike.com`
};
// Normalized via `new URL(...).origin` so an override with a trailing slash/path (e.g.
// "https://gs.example.com/") still produces an origin-only string matching MessageEvent.origin.
exports.GUEST_SESSION_ORIGIN = new URL(process.env.NEXT_PUBLIC_GUEST_SESSION_ORIGIN ||
    GUEST_SESSION_ORIGIN_FALLBACK_BY_HOST[exports.HOST_NAME] ||
    `https://${exports.HOST_NAME}`).origin;
exports.GUEST_SESSION_IFRAME_SRC = `${exports.GUEST_SESSION_ORIGIN}/static/uxf/guest-session-html/index.html`;
exports.MODAL_ROOT_ID = `modal-root`;
exports.DATA_CAPTURE_SCRIPT = (_h = (_g = process.env.WS_DATA_CAPTURE_SCRIPT) !== null && _g !== void 0 ? _g : process.env.NEXT_PUBLIC_DATA_CAPTURE_SCRIPT) !== null && _h !== void 0 ? _h : process.env.DATA_CAPTURE_SCRIPT;
exports.CN_GUEST_SESSION_SCRIPT = (_j = process.env.NEXT_PUBLIC_CN_GUEST_SESSION_SCRIPT) !== null && _j !== void 0 ? _j : process.env.CN_GUEST_SESSION_SCRIPT;
exports.PRIVACY_CORE_SCRIPT = (_k = process.env.PRIVACY_CORE_SCRIPT) !== null && _k !== void 0 ? _k : `https://${exports.SHARED_ASSET_HOST}/static/privacy-core/public/privacy-core.js`;
exports.ANALYTICS_SCRIPT = (_m = (_l = process.env.WS_ANALYTICS_SCRIPT) !== null && _l !== void 0 ? _l : process.env.NEXT_PUBLIC_ANALYTICS_SCRIPT) !== null && _m !== void 0 ? _m : process.env.ANALYTICS_SCRIPT;
exports.DEFAULT_WEB_SHELL_CLIENT_INFO = {
    identityProvider: null
};
/**
 * In supporting a new domain for China, Web Shell default locale should not be relied on.
 * Instead, experience teams are required to set the initial locale to avoid a breaking change.
 */
exports.DEFAULT_LOCALE_DATA = {
    cloudUrlFragment: ``,
    country: `us`,
    countryName: `United States`,
    countryNames: {
        en: `United States`
    },
    currency: `USD`,
    currencySymbol: `$`,
    default: true,
    hreflang: `en-US`,
    intl: `en-US`,
    langRegion: `en-US`,
    language: `en`,
    urlParam: `en`,
    translationsLanguage: `en-US`
};
exports.DEFAULT_USER_LOCATION_DATA = {
    country: ``,
    state: ``,
    latitude: ``,
    longitude: ``
};
exports.DISABLE_GUEST_SESSION_IFRAME = (_p = (_o = process.env.NEXT_PUBLIC_DISABLE_GUEST_SESSION_IFRAME) !== null && _o !== void 0 ? _o : process.env.DISABLE_GUEST_SESSION_IFRAME) !== null && _p !== void 0 ? _p : `false`;
//# sourceMappingURL=constants.js.map